export default (time) => {
  const hours = parseInt(time.split(':')[0], 10);
  const minutes = parseInt(time.split(':')[1], 10);

  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return 0;
  }

  const MINUTES_IN_DAY = 60 * 24;
  const PERCENT_PER_MINUTE = 100 / MINUTES_IN_DAY;

  return Math.round(((hours / 24) * 100) + (minutes * PERCENT_PER_MINUTE));
};



// WEBPACK FOOTER //
// ./src/utils/timeToXPosition.js